import type { OrganizationType } from "../types";

export const ORGANIZATION_TYPE_EN_LABELS: Record<OrganizationType, string> = {
  llp: "Limited Liability Partnership",
  llc: "Limited Liability Company",
  jsc: "Joint-Stock Company",
  ip: "Individual Entrepreneur",
  pf: "Public Foundation",
  prf: "Private Foundation",
  pa: "Public Association",
};
